import { GridWidget } from '../models/grid-widget/grid-widget';
import { Observable, BehaviorSubject } from 'rxjs';

/**
 * The GridWidgetService allows you to register GridWidget configuration objects.  They then get accessed
 * by the grid widget components through the id that gets passed into them.
 */
export class GridWidgetService {

  private registeredGridWidget: Record<string, BehaviorSubject<GridWidget | undefined>> = {};

  constructor() {}

  /**
   * Associates the GridWidget object being passed in with the id passed in.
   */
  registerGridWidget(gridWidget: GridWidget, id: string): void {
    if (this.registeredGridWidget[id] != null) {
      this.registeredGridWidget[id].next(gridWidget);
    } else {
      this.registeredGridWidget[id] = new BehaviorSubject(gridWidget);
    }
  }

  /**
   * Gets the GridWidget object registered to the specified ID.
   * You must subscribe to the Observable that is returned to get the GridWidget in question.
   */
  getGridWidget(id: string): Observable<GridWidget | undefined> {
    if (this.registeredGridWidget[id] == null) {
      this.registeredGridWidget[id] = new BehaviorSubject(undefined);
    }

    return this.registeredGridWidget[id];
  }
}
